import { IButtonProps, IconButton as FabricIconButton, TooltipHost } from "@fluentui/react";
import * as React from "react";

interface DetailsButtonProps extends IButtonProps {
    testId?: string;
}

export const DetailsButton: React.FC<DetailsButtonProps> = (props: DetailsButtonProps) => {
    return (
        <TooltipHost content="Details" styles={{ root: { display: "inline-block" } }}>
            <FabricIconButton
                key={props.id}
                iconProps={{ iconName: "PageList" }}
                disabled={props.disabled}
                onClick={props.onClick}
                data-testId={props.testId}
            />
        </TooltipHost>
    );
};
